import React from 'react';
import styled, { keyframes } from 'styled-components';
import { contentColumnPadding } from '../../theme/constants';

const SkeletonLoader: React.FC = () => {
  return (
    <Wrapper>
      <Line $width="75%" />
      <Line $width="60%" />
      <Line $width="90%" />
      <Line $width="45%" />
      <Row>
        <Block />
        <Block />
        <Block />
      </Row>
    </Wrapper>
  );
};

export default SkeletonLoader;

const shimmer = keyframes`
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

const ShimmerBase = styled.div`
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.av2.surface} 25%,
    ${({ theme }) => theme.av2.borderSubtle} 50%,
    ${({ theme }) => theme.av2.surface} 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 5px;
`;

const Wrapper = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Line = styled(ShimmerBase)<{ $width: string }>`
  height: 14px;
  width: ${({ $width }) => $width};
`;

const Row = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;

const Block = styled(ShimmerBase)`
  height: 60px;
  flex: 1;
  border-radius: 10px;
`;
